import { createContext } from 'react';
import {
  defaultUpcomingCalendarViewOptions,
  UpcomingCalendarViewOptions,
} from 'shared/types/upcoming-calendar-view-options';

export type UpcomingCalendarViewOptionsContextProps = {
  viewOptions: UpcomingCalendarViewOptions;
  updateViewOptions: (update: Partial<UpcomingCalendarViewOptions>) => void;
};

export const UpcomingCalendarViewOptionsContext =
  createContext<UpcomingCalendarViewOptionsContextProps>({
    viewOptions: defaultUpcomingCalendarViewOptions,
    updateViewOptions: () => {},
  });
